import React from "react";
import PropTypes from "prop-types";
import { CreateContainer } from "./ContainerCreate";
import { getTrackRelatedTracks } from "../api/getTrack";
import Skeleton from "react-loading-skeleton";

class TrackRelatedContainer extends React.Component {
  componentDidMount() {
    const { trackId } = this.props;
    this.props.request(trackId);
  }
  componentWillReceiveProps(nextProps) {
    const { trackId: nextTrackId } = nextProps;
    const { trackId } = this.props;
    if (nextTrackId !== trackId) {
      this.props.request(nextTrackId);
    }
  }
  render = () => {
    const { data, loading, failure, render, max = 6 } = this.props;
    const tracks = (data && data.data) || [];
    if (loading) {
      return <Skeleton count={3} />;
    }
    if (!loading && tracks.length === 0) {
      return null;
    }

    return render({ tracks: tracks.sort(() => Math.random() - 0.5).slice(0, max), loading, failure });
  };
}

TrackRelatedContainer.propTypes = {
  trackId: PropTypes.string.isRequired,
  max: PropTypes.number,
};

export default CreateContainer(getTrackRelatedTracks, TrackRelatedContainer);
